import activationKeys from "../services/dstore.activation.keys";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        loading: false,
        errors: null,
        importUuid: null,
        importUuids: [],
        activationKeys: [],
        param: {
            page: 1,
            payload: {
                filters: {
                    // paired_key: "all",
                    keyword: "",
                    product_add_on_uuid: null
                }
            }
        },
        pagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0,
            perPage: 10
        }
    },
    mutations: {
        loading(state, status) {
            state.loading = status;
        },
        errors(state, errors) {
            if (errors !== null) {
                state.errors = errors.errors;
            } else {
                state.errors = errors;
            }
        },
        resetErrors(state) {
            state.errors = null;
        },
        setImportUuid(state, importUuid) {
            state.importUuid = importUuid;
            state.loading = false;
        },
        setImportUuids(state, importUuid) {
            state.importUuids.push(importUuid);
            state.loading = false;
        },
        removeUuidFromImportUuids(state, importUuid) {
            state.importUuids = state.importUuids.filter(
                uuid => uuid !== importUuid
            );
        },
        setInitialPageCount(state, list) {
            // console.log(list.length);
            state.pagination.initialPageCount = list.length;
        },
        setCurrentPage(state, page) {
            state.pagination.currentPage = page;
        },
        setPagination(state, pagination) {
            state.pagination.totalPerPage = pagination.list.length;
            state.pagination.maxPage =
                state.pagination.totalPerPage > 0 ? pagination.max_page : 0;
            state.pagination.prevPage = pagination.prev_page;
            state.pagination.nextPage = pagination.next_page;
            state.pagination.currentPage = state.pagination.prevPage + 1;
            state.pagination.currentFirstItem =
                state.pagination.totalPerPage > 0
                    ? state.pagination.initialPageCount *
                          state.pagination.prevPage +
                      1
                    : 0;
            state.pagination.currentLastItem =
                state.pagination.currentFirstItem > 0
                    ? state.pagination.currentFirstItem +
                      state.pagination.totalPerPage -
                      1
                    : 0;
        },
        setActivationKeys(state, activationKeys) {
            // console.log(products);
            state.activationKeys = activationKeys;
        },
        setParam(state, param) {
            state.param = param;
        }
    },

    actions: {
        async resetErrors({ commit }) {
            commit("resetErrors");
        },
        removeUuidFromImportUuids({ commit }, uuid) {
            commit("removeUuidFromImportUuids", uuid);
        },
        async getActivationKeys({ commit, state }, param) {
            commit("loading", true);
            state.products = [];
            try {
                let response = await activationKeys.getActivationKeys(param);

                if (param.page === 1) {
                    await commit("setInitialPageCount", response.data.list);
                }
                commit("setActivationKeys", response.data.list);
                commit("setPagination", response.data);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async updateActivationKey({ commit }, param) {
            commit("loading", true);
            try {
                let response = await activationKeys.updateActivationKey(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async deleteActivationKey({ commit }, param) {
            commit("loading", true);
            try {
                let response = await activationKeys.deleteActivationKey(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getImportsStatus({ commit }, uuid) {
            commit("loading", true);
            try {
                let param = {
                    import_code: uuid
                };
                let response = await activationKeys.getImportsStatus(param);
                commit("loading", false);
                return response;
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async importActivationKeys({ commit }, param) {
            commit("loading", true);
            try {
                let response = await activationKeys.importActivationKeys(param);
                commit("setImportUuid", response.data.import_code); // Set import data for initial notification
                commit("setImportUuids", response.data.import_code); // List of UUIDs being uploaded
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot import activation keys.");
                commit("errors", errors);
                commit("loading", false);
            }
        }
    }
};
